import type { CalculatorInput } from './defaults';

/** UI-флаги функций (на расчёт влияют только personalManager / marketingSupport) */
export interface FeatureFlags {
	featureTrade: boolean;
	featureStock: boolean;
	featureLogistics: boolean;
	featureCrm: boolean;
	featureCommunication: boolean;
	featureDocuments: boolean;
	featureOtc: boolean;
	featureAnalytics: boolean;
	featureDashboard: boolean;
	featureTraining: boolean;
	featureApi: boolean;
}

export type FormValues = CalculatorInput & FeatureFlags;

export const DEFAULT_FEATURES: FeatureFlags = {
	featureTrade: true,
	featureStock: true,
	featureLogistics: true,
	featureCrm: true,
	featureCommunication: true,
	featureDocuments: true,
	featureOtc: true,
	featureAnalytics: true,
	featureDashboard: true,
	featureTraining: true,
	featureApi: false,
};

export const CONTACT_FIELDS = ['company', 'name', 'phone'] as const;

export const contactRule = {
	validator: async (_: unknown, value: string) => {
		if (typeof value === 'string' && value.trim().length > 1) return;
		throw new Error('Обязательное поле');
	},
};
